"use client";

import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

import TurnstileCaptcha from "@/components/molecules/turnstile-widget/turnstile-captcha";
import useTurnstile from "@/hooks/use-turnstile/use-turnstile";

import { setContactPageShiftFlowValue } from "../components/contact-details/utils/contact-details-page.util";

export default function Template({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const {
    isTurnstileEnabled,
    siteKey,
    handleTurnstileToken,
    handleError,
    handleExpireToken,
    handleUnsupportedBrowser,
  } = useTurnstile();

  const searchParams = useSearchParams();
  const contactExpFlow = searchParams.get("contactExpFlow");
  const quoteId = searchParams.get("quoteId");
  useEffect(() => {
    if (contactExpFlow) {
      setContactPageShiftFlowValue(contactExpFlow);
    } else if (!contactExpFlow && quoteId) {
      setContactPageShiftFlowValue("control");
    }
  }, [contactExpFlow, quoteId]);

  return (
    <div>
      {children}
      <TurnstileCaptcha
        isEnabled={isTurnstileEnabled}
        siteKey={siteKey}
        theme="light"
        containerId="cf-turnstile"
        onSuccess={handleTurnstileToken}
        onError={handleError}
        onExpireToken={handleExpireToken}
        onUnsupportedBrowser={handleUnsupportedBrowser}
      />
    </div>
  );
}
